// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mapButtons{display:flex;flex-direction:column;position:fixed;bottom:47px;left:388px;justify-content:space-between;gap:8px}.mapButtons.MOBILE{left:10px}.mapButtons>div{height:42px}", ""]);
// Exports
module.exports = exports;
